import React, { useLayoutEffect, useRef } from 'react';
export const ProductCardSkeleton = () => React.createElement(React.Fragment, null,
    React.createElement("div", { className: "skeleton", style: { paddingTop: '100%' } }),
    React.createElement("span", { className: "skeleton d:inline-block", style: { marginTop: '0.4107em', height: '1.3753em', width: '80%' } }),
    React.createElement("span", { className: "skeleton d:inline-block", style: { height: '0.9450em', width: '40%' } }));
export const ProductCardVNode = ({ hit, filters, imageSizes, clickHandler }) => {
    const ref = useRef(null);
    useLayoutEffect(() => {
        if (ref.current !== null) {
            ref.current._hit = hit;
        }
    }, [hit]);
    useLayoutEffect(() => {
        if (ref.current !== null) {
            ref.current._filters = filters;
        }
    }, [filters]);
    useLayoutEffect(() => {
        if (ref.current !== null) {
            ref.current._imageSizes = imageSizes;
        }
    }, [imageSizes]);
    useLayoutEffect(() => {
        if (ref.current !== null) {
            ref.current._clickCallback = clickHandler;
        }
    }, [clickHandler]);
    return (React.createElement("product-card-new-component", { ref: ref }));
};
